import { render } from "./AutoComplete.vue?vue&type=template&id=a87e5dfc&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=a87e5dfc&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87e5dfc"]])

export default __exports__